import { styled } from "@mui/system"

import { rem } from "polished"
import { Box, AppBar } from "@mui/material"
import ButtonUnstyled from "@mui/base/ButtonUnstyled"

const StyledSocialNav = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
}))

const StyledAppBar = styled(AppBar)(({ appBarWhite, theme }) => ({
  backgroundColor: appBarWhite ? "white" : "initial",
  transition: "all 500ms",
  [theme.breakpoints.down("xs")]: {
    backgroundColor: "white",
  },
  [theme.breakpoints.up("sm")]: {
    backgroundColor: "white",
  },
}))
const StyledNavigation = styled(Box)({
  padding: `${rem(1)}`,
})

const StyledNavElement = styled(ButtonUnstyled)(({ activeStyle, theme }) => ({
  backgroundColor: "transparent",
  border: 0,
  fontSize: `${rem(16)}`,
  fontWeight: activeStyle ? "strong" : "inherit",
  color: theme.palette.secondary.main,

  textDecoration: "none",
  transition: "all 500ms",
  position: "relative",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  "&:after": {
    content: "''",
    height: "2px",
    position: "absolute",
    bottom: "0",
    left: "0",
    width: "100%",
    backgroundColor: theme.palette.primary.main,
    transition: "all 200ms",
    clipPath: "polygon(50% 0, 50% 0, 50% 100%, 50% 100%)",
  },
  "&:hover": {
    color: theme.palette.alternate.main,
    cursor: "pointer",
    "&:after": {
      clipPath: "polygon(10% 0, 90% 0, 90% 100%, 10% 100%)",
    },
  },
}))

export { StyledSocialNav, StyledAppBar, StyledNavigation, StyledNavElement }
